import convert from 'color-convert'

export { lighten, isValidHexColor, shades }

export type ColorScheme = {
  color: string
  highlightColor: string
  border: string,
  highlightBorder: string
  shadow: string
}

function lighten(color: string, percent: number): string {
  const c = convert.hex.hsv(color)
  c[2] = Math.min(100, c[2] + percent)
  return '#' + convert.hsv.hex(c)
}

function darken(color: string, percent: number): string {
  const c = convert.hex.hsv(color)
  c[2] = Math.max(0, c[2] - percent)
  return '#' + convert.hsv.hex(c)
}

function desaturate(color: string, percent: number): string {
  const c = convert.hex.hsv(color)
  c[1] = Math.max(0, c[1] - percent)
  return '#' + convert.hsv.hex(c)
}

function isValidHexColor(hex: string) {
  return /^#([0-9A-F]{3}){1,2}$/i.test(hex)
}

function shades(color: string): ColorScheme {
  return {
    color: color,
    highlightColor: darken(color, 20),
    border: color,
    highlightBorder: lighten(color, 2.5),
    shadow: lighten(desaturate(color, 50), 0)
  }
}
